import clsx from 'clsx'

const PRIORITY_CONFIG: Record<string, { color: string; label: string }> = {
  low: { color: 'bg-gray-400', label: 'Low' },
  medium: { color: 'bg-blue-400', label: 'Medium' },
  high: { color: 'bg-orange-400', label: 'High' },
  critical: { color: 'bg-red-500', label: 'Critical' },
}

export function PriorityBadge({ priority }: { priority: string }) {
  const config = PRIORITY_CONFIG[priority] || PRIORITY_CONFIG.medium
  return (
    <span className="inline-flex items-center gap-1.5 text-xs text-gray-500">
      <span className={clsx('w-2 h-2 rounded-full', config.color)} />
      {config.label}
    </span>
  )
}
